/* eslint-disable no-unused-vars */
import { useState, useEffect, useMemo } from "react";
import services from "commons/apis/index";

const useGetProjects = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [count, setCount] = useState(10);
  const [page, setPage] = useState(0);
  useEffect(() => {
    const getProjects = async () => {
      try {
        const model = {
          count,
          page,
        };
        setLoading(true);
        const { items } = await services.getPublicProjects(model);
        if (!items) {
          return null;
        }
        setData(items);
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    };
    getProjects();
  }, [count, page]);
  const { projects } = useMemo(() => {
    const projects = data.map((item) => {
      const { id, name } = item.project;
      return { id, name };
    });
    return { projects };
  }, [data]);
  return {
    loading,
    projects,
    data,
  };
};
export default useGetProjects;
